import axios from 'axios'
import * as vars from './vars';

    // metric - students|meetings|ratings|favorites|searches
    export function getMetrics(organization, metric, ipedsid, jwt) {
        return axios({
            method: 'GET',
            url: vars.baseURL + `/api/v1/counsel/${organization}/metrics/${metric}`,
            headers: { api_key: vars.apiKey, 'X-XSRF-TOKEN': vars.csrfToken, 'Authorization': `Bearer ${jwt}`},
            data: {
                metric: metric,
                organization: organization,
                ipedsid: ipedsid
            }
        })
    }


export function  getRepresentedCollegesCount (){
    return axios({
        method: 'POST',
        url: vars.baseURL + '/api/v3/untrusted/metrics/GetCollegeCount',
        headers: { api_key: vars.apiKey, 'X-XSRF-TOKEN': vars.csrfToken},
        data : {}
    })
}

export function getMentorCount (){
    return axios({
        method: 'POST',
        url: vars.baseURL + '/api/v3/untrusted/metrics/GetMentorCount',
        headers: { api_key: vars.apiKey, 'X-XSRF-TOKEN': vars.csrfToken},
        data : {}
    })
}